import type { Filters, Pagination } from '../../../services/types'
import { getRequestParamString } from '../../../services/utils/utils'

/**
 * Maps Table.vue filter UI to expense list endpoints (filters[] + pagination).
 * Backend list handlers expect indexed `filters[n][column]`, `filters[n][search]`, etc. (not legacy `?column=&search=` only).
 */
function normalizeExpenseListFilters(filters?: Partial<Filters>): Partial<Filters> | undefined {
  if (!filters) {
    return undefined
  }

  if (filters.filters !== undefined) {
    return filters
  }

  const column = filters.column
  const search = filters.search
  if (column && search !== undefined && search !== '') {
    return {
      filters: [{ id: '0', column, search: String(search) }],
    }
  }

  if (filters.start_date || filters.end_date) {
    return {
      filters: [
        {
          id: '0',
          column: 'created_at',
          search: '',
          start_date: filters.start_date,
          end_date: filters.end_date,
        },
      ],
    }
  }

  return undefined
}

/** Query string for GET expense categories/items (matches ListExpenseCategoriesRequest / ListExpenseItemsRequest). */
export function getExpenseListParamString(filters?: Partial<Filters>, pagination?: Partial<Pagination>): string {
  return getRequestParamString(normalizeExpenseListFilters(filters), pagination)
}
